import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '~/components/shared/Card/Card';
import CardHeader from '~/components/shared/CardHeader/CardHeader';
import CardSection from '~/components/shared/CardSection/CardSection';
import useTranslate from '~/hooks/useTranslate';
import { Offer } from '~/Interfaces';
import LoanPurpose from '~/components/shared/LoanPurpose/LoanPurpose';
import { RootState } from '~/store/types/sharedTypes';
import { updateOfferData } from '~/store/actions/loanOfferActions';
import { LoanPurposes } from '~/enums';
import { onChangeInputEvent } from '~/types/types';

interface LoanInfoCardProps {
  data: Offer;
}

const LoanInfoCard = ({ data: offerData }: LoanInfoCardProps) => {
  const translate = useTranslate();
  const dispatch = useDispatch();

  const { loanPurposeManual, purposeOfLoan } = useSelector(
    (state: RootState) => state.loanOffer.userData
  );

  useEffect(() => {
    dispatch(
      updateOfferData({
        purposeOfLoan: offerData.purposeOfLoan,
        loanPurposeManual: offerData.loanPurposeManual,
      })
    );
  }, [offerData]);

  const loanPurposeManualHandler = (event: onChangeInputEvent) => {
    dispatch(
      updateOfferData({
        loanPurposeManual: event.currentTarget.value,
      })
    );
  };

  const onLoanPurposeChanged = (value: LoanPurposes) => {
    dispatch(updateOfferData({ purposeOfLoan: value }));
  };

  return (
    <Card noPadding dataTestId="loan-offer-info-card">
      <CardHeader value={translate('LoanInfoCard.Title') as string} />
      <CardSection
        title={translate('LoanInfoCard.CompanyName') as string}
        value={offerData.companyName}
        borderTop
      />
      <CardSection
        title={translate('LoanInfoCard.OrgNumber') as string}
        value={offerData.companyNumber}
        borderTop
      />
      <CardSection
        title={translate('LoanInfoCard.LenderRepresentative') as string}
        value={offerData.representativeName}
        borderTop
        borderBottom
      />
      <CardSection>
        <LoanPurpose
          loanPurposeManual={loanPurposeManual || ''}
          defaultValue={offerData.purposeOfLoan}
          value={purposeOfLoan}
          loanPurposeHandler={onLoanPurposeChanged}
          loanPurposeManualHandler={loanPurposeManualHandler}
        />
      </CardSection>
    </Card>
  );
};

export default LoanInfoCard;
